// src/components/rcv/SimplePdfViewer.jsx
import React, { useState } from 'react';
import { Box, Paper, IconButton, Tooltip, LinearProgress } from '@mui/material';
import { ZoomIn, ZoomOut, Refresh } from '@mui/icons-material';

const SimplePdfViewer = ({ pdfUrl }) => {
  const [zoomLevel, setZoomLevel] = useState(100);
  const [loading, setLoading] = useState(true);

  // Función para aumentar el zoom
  const handleZoomIn = () => {
    setZoomLevel(prev => Math.min(prev + 10, 200)); // Máximo 200%
  };

  // Función para disminuir el zoom
  const handleZoomOut = () => {
    setZoomLevel(prev => Math.max(prev - 10, 50)); // Mínimo 50%
  };

  // Función para resetear el zoom
  const handleResetZoom = () => {
    setZoomLevel(100);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      {/* Barra de herramientas */}
      <Paper sx={{ 
        p: 1, 
        display: 'flex', 
        justifyContent: 'flex-end', 
        gap: 1,
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        borderRadius: 0
      }}>
        <Tooltip title="Reducir zoom">
          <IconButton onClick={handleZoomOut} size="small">
            <ZoomOut fontSize="small" />
          </IconButton>
        </Tooltip>
        
        <Tooltip title="Restaurar zoom (100%)">
          <IconButton onClick={handleResetZoom} size="small">
            <Refresh fontSize="small" />
          </IconButton>
        </Tooltip>
        
        <Tooltip title="Aumentar zoom">
          <IconButton onClick={handleZoomIn} size="small">
            <ZoomIn fontSize="small" />
          </IconButton>
        </Tooltip>
      </Paper>
      
      {/* Visor del PDF con zoom */}
      <Box sx={{ 
        flexGrow: 1, 
        position: 'relative',
        overflow: 'auto',
        bgcolor: '#f0f0f0'
      }}>
        {loading && (
          <LinearProgress 
            sx={{ 
              position: 'absolute', 
              top: 0, 
              left: 0, 
              right: 0,
              zIndex: 1
            }} 
          />
        )}
        
        <Box sx={{ 
          display: 'flex',
          justifyContent: 'center',
          p: 2,
          minHeight: '100%'
        }}>
          <iframe
            src={`${pdfUrl}#view=FitH`}
            title="Visor de PDF"
            style={{
              width: `${zoomLevel}%`,
              border: 'none',
              backgroundColor: 'white',
              boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
            }}
            onLoad={() => setLoading(false)}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default SimplePdfViewer;